function StepNavigation({ steps, currentStep, maxStepReached = 0, onStepSelect }) {
  return (
    <nav className="landstar-step-nav" aria-label="Redemption progress">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === step.id;
        const isComplete = steps.findIndex((item) => item.id === currentStep) > index;
        const isAvailable = index <= maxStepReached;
        const showConnector = index < steps.length - 1;

        return (
          <div
            key={step.id}
            className={`landstar-step-node${isActive ? " is-active" : ""}${isComplete ? " is-complete" : ""}${isAvailable ? " is-available" : ""}`}
          >
            <button
              type="button"
              className="landstar-step-trigger"
              disabled={!isAvailable}
              onClick={() => onStepSelect?.(step.id)}
            >
              <span className="landstar-step-badge">
                <span className="landstar-step-badge-inner">{stepNumber}</span>
              </span>
              <span className="landstar-step-label">{step.label}</span>
            </button>
            {showConnector ? (
              <span className="landstar-step-line" aria-hidden="true">
                <span className="landstar-step-line-progress" />
              </span>
            ) : null}
          </div>
        );
      })}
    </nav>
  );
}

export default StepNavigation;
